
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MacroDefinitionDto,
  MacroDeleteResultDto,
  MacroGetDto
} from 'webcommon/shared';
import { PrmHttpClientService } from 'webcommon/webapi';
@Injectable({
  providedIn: 'root',
})
export class MacroRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) { }

  getMacroList(macroGetDto: MacroGetDto): Observable<MacroDefinitionDto[]> {
    const endpointUrl = `macros/list`;
    return this.httpClientService.sendPostRequest(endpointUrl, macroGetDto);
  }

  saveMacro(macroDefinition: MacroDefinitionDto): Observable<MacroDefinitionDto> {
    const endpointUrl = `macros/save`;
    return this.httpClientService.sendPostRequest(endpointUrl, macroDefinition);
  }

  deleteMacro(macroId: string): Observable<MacroDeleteResultDto> {
    const endpointUrl = `macros/delete/${macroId}`;
    return this.httpClientService.sendDeleteRequest(endpointUrl);
  }
}
